module.exports = __webpack_public_path__ + "static/img/solutionValuePic01.1949e7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionValuePic01.png
// module id = 40a3
// module chunks = 0